import { Injectable } from '@angular/core';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { Observable } from 'rxjs';
import { PreviousRouteService } from 'app/shared/previous-route.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Secretaria } from 'app/core/interfaces/secretaria.interface';
import { Pagination } from 'app/core/interfaces/pagination.interface';
import { Acesso } from 'app/core/interfaces/acesso.interface';


@Injectable({
  providedIn: 'root'
})
export class WebviewService {

  usuario: any;
  navigation: any;
  constructor(
    private _apigestacard: APIGestaCardService,
    private previousRouteService: PreviousRouteService
  ) { 
  }

  GetPreviousUrl() {
    return this.previousRouteService.getPreviousUrl();
  }

  GetUserData(): Observable<any> {  
    return this._apigestacard.GetMeObs();
  }

  ConsultarDados(token?: string): Promise<Acesso> {
    return this._apigestacard.ConsultarDadosAcesso(token);
  }

  ConsultarDadosObs(token?: string): Observable<Acesso> {
    return this._apigestacard.ConsultarDadosAcessoObservable(token);
  }

  GetInfoProfissional(id: string) {
    return this._apigestacard.GetUsuarioPorId(id);
  }

  GetInfoEnfermeiro(id: string) {
    return this._apigestacard.PegarUmEnfermeiroPorId(id);
  }

  GetInfoEnfermeiroObs(id: string) {
    return Observable.create((observer) => {

      this._apigestacard.PegarUmEnfermeiroPorId(id)
        .then(paciente => {
          observer.next(paciente)
          observer.complete()
        })
        .catch(err => observer.error(err))

    })
  }

  GetInfoMedico(id: string) {
    return this._apigestacard.PegarUmMedicoPorId(id);
  }

  GetInfoMedicoObs(id: string) {
    return Observable.create((observer) => {

      this._apigestacard.PegarUmMedicoPorId(id)
        .then(paciente => {
          observer.next(paciente)
          observer.complete()
        })
        .catch(err => observer.error(err))

    })
  }

  GetConsultasEnfermeiro() {
    return this._apigestacard.ListaConsultasEnfermeiro(this.usuario.email);
  }

  GetConsultasMedico() {
    return this._apigestacard.ListaConsultasEnfermeiro(this.usuario.email);
  }

  GetConsultaPorCartao(id_cartao: string) {
    return this._apigestacard.ListaConsultasPorCartao(id_cartao);
  }

  GetListaSecretarias() {
    return this._apigestacard.PegarListaSecretarias();
  }

  AtualizarSenha(senhaAtual: string, novaSenha: string, novaSenhaConfirmacao: string): Promise<any> {
    return this._apigestacard.AlterarSenha(senhaAtual, novaSenha, novaSenhaConfirmacao);
  }

  AlterarEmailPaciente(pacienteId, email) {
    return this;
  }

  GetSecretariaPorId(id: string): Promise<Secretaria> {
    return this._apigestacard.PegarSecretariaPorId(id);
  }

  GetListaPaciente(enfermeiroId: string) {
    return this._apigestacard.PegarListaPacientesDeUmEnfermeiro(enfermeiroId);
  }

  GetListaPacientePage(page: number = 1, limit: number = 12, search: object = {}): Observable<Pagination<Paciente>> {
    return this._apigestacard.PegarListaPacientesDeUmEnfermeiroPage(page, limit, search);
  }

  GetPacientePorEmail(email_paciente: string, id?: string): Promise<Paciente> {
    return this._apigestacard.PegarPacientePorEmail(email_paciente, id);
  }

  GetPacientePorId(id: string): Promise<Paciente> {
    return this._apigestacard.PegarPacientePorIdCompletasso(id);
  }

  GetPacientePorIdObs(id: string): Observable<Paciente> {
    return this._apigestacard.PegarPacientePorIdCompletassoObservable(id);
  }

  LerCartaoAtivoPaciente(email_paciente: string): Promise<any> {
    return this._apigestacard.LerOCartaoAtivo(email_paciente);
  }

  LerUltimoCartao(email_paciente: string): Promise<any> {
    return this._apigestacard.LerUltimoCartao(email_paciente);
  }

  LerUmCartao(cartao_id: string) {
    return this._apigestacard.LerUmCartaoGestante(cartao_id);
  }

  LerUmCartaoObs(cartao_id: string) {
    return this._apigestacard.LerUmCartaoGestanteObservable(cartao_id);
  }

  RegistrarEncerramento(id_cartao: string, encerramentoObj: object) {
    return this._apigestacard.RegistrarEncerramento(id_cartao, encerramentoObj);
  }

  AtualizarCartao(cartao_id: string, cartao_atualizado: any) {
    return this._apigestacard.AtualizarCartao(cartao_id, cartao_atualizado);
  }

  GetSomenteUmEnfermeiro(email: string): Promise<any> {
    return this._apigestacard.PegarUmEnfermeiroPorEmail(email);
  }

  MudarStatusArquivo(arquivo_id: string, status: 'pendente' | 'processado' | 'utilizado'): Promise<any> {
    return this._apigestacard.MudarStatusArquivo(arquivo_id, status);
  }

  CriarConsulta(dados_consulta: any, email_enfermeiro: string, email_paciente: string, id_cartao: string): Promise<any> {
    return this._apigestacard.CriarConsulta(email_paciente, email_enfermeiro, id_cartao, dados_consulta);
  }

  AtualizarConsulta(dados_consulta: any, consulta_id: string): Promise<any> {
    return this._apigestacard.AlterarConsulta(consulta_id, dados_consulta);
  }

  ExcluirConsulta(consulta_id: string): Promise<any> {
    return this._apigestacard.DeletarConsulta(consulta_id);
  }

  ListarConsultasEnfermeiro(email_enfermeiro: string): Promise<any> {
    return this._apigestacard.ListaConsultasEnfermeiro(email_enfermeiro);
  }
}
